import { render, staticRenderFns } from "./StickersMaterialEdit.vue?vue&type=template&id=fe4090e0&"
import script from "./StickersMaterialEdit.vue?vue&type=script&lang=js&"
export * from "./StickersMaterialEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports